import { EVENT_DATE, EVENT_END_DATE, EVENT_TITLE, EVENT_LOCATION, EVENT_DETAILS } from "../config/event";

const isoZ = (d) => d.toISOString().replace(/\.\d{3}Z$/, "Z");
const compact = (d) => isoZ(d).replace(/[-:]/g, "");
const qs = (o) => new URLSearchParams(o).toString().replace(/\+/g, "%20");

export const ICS_URL = `${process.env.REACT_APP_BACKEND_URL}/api/calendar.ics?${qs({
  start: isoZ(EVENT_DATE),
  end: isoZ(EVENT_END_DATE),
  title: EVENT_TITLE,
  location: EVENT_LOCATION,
  details: EVENT_DETAILS,
})}`;

export const GOOGLE_CALENDAR_URL = `https://calendar.google.com/calendar/render?${qs({
  action: "TEMPLATE",
  text: EVENT_TITLE,
  dates: `${compact(EVENT_DATE)}/${compact(EVENT_END_DATE)}`,
  details: EVENT_DETAILS,
  location: EVENT_LOCATION,
})}`;

export const OUTLOOK_CALENDAR_URL = `https://outlook.live.com/calendar/0/deeplink/compose?${qs({
  path: "/calendar/action/compose",
  rru: "addevent",
  subject: EVENT_TITLE,
  startdt: isoZ(EVENT_DATE),
  enddt: isoZ(EVENT_END_DATE),
  body: EVENT_DETAILS,
  location: EVENT_LOCATION,
})}`;

export const ICS_FILENAME = "weaponized-credit-to-capital.ics";
